import { useMemo } from "react"
import { useQuery } from "@apollo/client"

import { COACH_TOOLS_API } from "../apolloClient"
import { SECTION_EMPLOYMENT_VERIFICATION_QUERY } from "../components/queries/sectionEmploymentVerification"
import { flags, useFeatureFlags } from "../lib/feature-flags"

/**
 * Which of the person's Member applications are waiting on the section to
 * verify employment. Behind `applications-membership`. A query error reports
 * none, so the existing submitted status stays.
 */
export function useSectionEmploymentVerification({ skip = false } = {}) {
  const [applicationsMembershipEnabled] =
    useFeatureFlags([flags.FLAG_FEAT_APPLICATIONS_MEMBERSHIP]) ?? []
  const skipQuery = skip || applicationsMembershipEnabled !== true

  const { data, loading, error } = useQuery(
    SECTION_EMPLOYMENT_VERIFICATION_QUERY,
    {
      context: { api: COACH_TOOLS_API },
      fetchPolicy: "no-cache",
      errorPolicy: "all",
      skip: skipQuery,
    },
  )

  const awaitingById = useMemo(() => {
    const ids = new Map()
    if (skipQuery || error) return ids
    for (const application of data?.membershipApplications || []) {
      if (
        application?.id &&
        application.awaitingSectionEmploymentVerification
      ) {
        ids.set(application.id, true)
      }
    }
    return ids
  }, [skipQuery, error, data])

  return {
    awaitingById,
    loading: skipQuery ? false : loading,
  }
}
